module.exports = __webpack_public_path__ + "img/GBCMA.adc576e95504f9d98a0a70d94060cec6.png";